import React from 'react';
import { Helmet } from "react-helmet";
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import './style.css';
import UpcomingEvents from 'components/UpcomingEvents/UpcomingEvents';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Footer from 'components/Footer/Footer';
import Button from 'components/Button/Button';
import { dateConvert, unixDateConversion, DaysDiff, HoursDiff, unixTimeStamp, current_unix_stamp } from 'utils/Helper';
// , get_current_unix_stamp
import { org_friendly_url, apiUrl, events_search_list_api, location_search, HeaderConfig, searchUrl } from 'Api/Api';
//import {asyncContainer, Typeahead} from 'react-bootstrap-typeahead';
import {withAsync, Typeahead} from 'react-bootstrap-typeahead';
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import { Map, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import geoLocation from './geoLocation';
import geoLocation from 'utils/geoLocation';
import iconDark from '../../Assets/icon-pin-dark.png';
import iconLight from '../../Assets/icon-pin-light.png';
import { local_routes } from 'utils/Routes';
import home from 'Assets/home.svg';
import { Link } from "react-router-dom";

//const AsyncTypeahead = asyncContainer(Typeahead);
const AsyncTypeahead = withAsync(Typeahead);

const mapStyles = {
  width: '100%',
  height: '100%',
};

class Events extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user_lat: '',
      user_lon: '',
      all_location_info: [],
      org_data: {},
      showingInfoWindow: false,
      isLoading: false,
      isBannerLoading: false,
      options: [],
      showComponent: false,
      cat_Arr: null,
      activeMarker: {},
      eventsData: null,
      loading: true,
      initialCenter: { lat: 0, lng: 0 },
      stores: [],
      //sortValue: "DESC",
      sortValue: "ASC",
      org_sortValue: "DESC",
      selectedMarkerData: {},
      //startDate: new Date(),
      startDate: null,
      endDate: null,
      //endDateUnixDate: null,
      //startDateUnixDate: null,
      selectedCity: '',
      bannerSelectedCity: '',
      isNoMoreEvents: false,
      zoomLevel: 2,
      from: 0,
      limit: 6
    }
    
    this.workspace_base_url = "";
    if (org_friendly_url) {
      this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
    }
    
  }
  
  // populates map with markers
  displayMarkers = (stores) => {
    console.log("DISPLAY MARKERS",stores.length);
    return stores.filter( element => element.show_marker ).map((store, index) => {
      const hasNextEvent = !!Object.keys(store.next_event).length;
      return (<Marker key={index} id={index} position={{
        lat: store.lat,
        lng: store.lon,
      }}
        icon={hasNextEvent ? iconDark : iconLight}
        entity_name={store.entity_name}
        friendly_url={store.friendly_url}
        next_event={hasNextEvent ? store.next_event : null}
        onClick={this.onMarkerClick} />)
    });
    
  }

  onInfoWindowClose = () => {
    this.setState({
      showingInfoWindow: false,
      activeMarker: null
    })
  }

  //  Marker functionality starts here
  onMarkerClick = async ({ entity_name, friendly_url, next_event }, marker) => {
    this.setState({
      activeMarker: marker,
      showingInfoWindow: true,
      selectedMarkerData: {
        name: entity_name,
        url: `${local_routes.cities}/${friendly_url}`,
        ...(next_event && { eventName: next_event.event_name, startTime: next_event.start_time }),
        ...(!next_event && { comingSoon: 'New Events Coming Soon!' }),
        bannerSelectedCity: entity_name
      }
    });
    await this.defaultEventSearch(entity_name);
  }

  orgEventSearch = async (org_entity_uuid) => {
    let [future_events_response,past_events_response] = await Promise.all([
      axios.get(`${events_search_list_api}?start_time_order=ASC&search_start_time=${current_unix_stamp}&from=0&limit=21`),
      axios.get(`${events_search_list_api}?start_time_order=DESC&search_end_time=${current_unix_stamp}&from=0&limit=21`)
    ]);
    
    let all_eventsData = [];

    let found_future_events = false;
    if (future_events_response.data && future_events_response.data.search_query_results && future_events_response.data.search_query_results.length > 0) {
      found_future_events = true;
      for (let item of future_events_response.data.search_query_results) {
        let entity = item.entity_info;
        all_eventsData.unshift(entity);
        //all_eventsData.push(entity);
      }
    }
    
    if (past_events_response.data && past_events_response.data.search_query_results && past_events_response.data.search_query_results.length > 0) {
      //past_eventsData.data.search_query_results = past_eventsData.data.search_query_results.reverse();
      for (let item of past_events_response.data.search_query_results) {
        let entity = item.entity_info;
        all_eventsData.push(entity);
        //all_eventsData.unshift(entity);
        if (all_eventsData.length >= 42) {
          // we have our 3! bailout
          all_eventsData.length = 42;
          break;
        }
      }
    }
    
    const eventsData = this.getConstructedEventDataShort(all_eventsData);
    
    // get form startData and endDate from the events we got
    let form_startDate = new Date((current_unix_stamp - 31536000) * 1000); // 1 year earlier
    let form_endDate = new Date((current_unix_stamp + 15552000) * 1000); // 6 months in future
    if (all_eventsData.length > 0 && all_eventsData[0].start_time) {
      form_endDate = unixDateConversion(all_eventsData[0].start_time);
    }
    if (all_eventsData.length > 0 && all_eventsData[all_eventsData.length-1].start_time) {
      form_startDate = unixDateConversion(all_eventsData[all_eventsData.length-1].start_time);
    }
    
    this.setState({
      startDate: form_startDate,
      endDate: form_endDate,
      eventsData,
      //bannerSelectedCity: locations_text,
      //selectedCity: locations_text,
      loading: false
    });
    
  }

  defaultEventSearch = async (locations_text) => {
    // get events from API - by default we want the next 3 events, and the past 6 events. Ideally we want 3 past and 3 future.
    let get_events_promises = [];
    //get_events_promises.push(axios.get(`${events_search_list_api}?start_time_order=ASC&locations_text=${locations_text}&search_start_time=${current_unix_stamp}&from=0&limit=3`, HeaderConfig))
    //get_events_promises.push(axios.get(`${events_search_list_api}?start_time_order=DESC&locations_text=${locations_text}&search_end_time=${current_unix_stamp}&from=0&limit=9`, HeaderConfig))

    // future events
    let params = {
      start_time_order: 'ASC',
      //search_start_time: get_current_unix_stamp(),
      search_start_time: current_unix_stamp,
      from: 0,
      limit: 30
    }
    if (locations_text) {
      params.locations_text = locations_text;
    }
    get_events_promises.push(axios.get(`${events_search_list_api}`, { params }));

    // past events
    params = {
      start_time_order: 'DESC',
      //search_end_time: get_current_unix_stamp(),
      search_end_time: current_unix_stamp,
      from: 0,
      limit: 12
    }
    if (locations_text) {
      params.locations_text = locations_text;
    }
    if (locations_text) {
      get_events_promises.push(axios.get(`${events_search_list_api}`, { params }));
    }

    let get_events_responses = await Promise.all(get_events_promises);
    
    //console.log("API",JSON.stringify(get_events_responses,null,2));
    let all_eventsData = [];
    
    // first do future events
    let found_future_events = false;
    let future_eventsData = get_events_responses[0];
    if (future_eventsData.data && future_eventsData.data.search_query_results && future_eventsData.data.search_query_results.length > 0) {
      found_future_events = true;
      for (let item of future_eventsData.data.search_query_results) {
        let entity = item.entity_info;
        //all_eventsData.unshift(entity);
        all_eventsData.push(entity);
      }
    }
    
    if (get_events_responses[1] && !found_future_events) {
      let past_eventsData = get_events_responses[1];
      
      if (past_eventsData.data && past_eventsData.data.search_query_results && past_eventsData.data.search_query_results.length > 0) {
        past_eventsData.data.search_query_results = past_eventsData.data.search_query_results.reverse();
        for (let item of past_eventsData.data.search_query_results) {
          let entity = item.entity_info;
          //all_eventsData.push(entity);
          all_eventsData.unshift(entity);
          if (all_eventsData.length >= 9) {
            // we have our 3! bailout
            all_eventsData.length = 9;
            break;
          }
        }
      }
    }
    
    const eventsData = this.getConstructedEventDataShort(all_eventsData);
    
    // get form startData and endDate from the events we got
    let form_startDate = new Date((current_unix_stamp - 31536000) * 1000); // 1 year earlier
    let form_endDate = new Date((current_unix_stamp + 15552000) * 1000); // 6 months in future
    if (all_eventsData.length > 0 && all_eventsData[0].start_time) {
      //form_endDate = unixDateConversion(all_eventsData[0].start_time);
      if (!found_future_events) {
        form_startDate = unixDateConversion(all_eventsData[0].start_time);
      } else {
        form_startDate = unixDateConversion(current_unix_stamp);
      }
    }
    if (all_eventsData.length > 0 && all_eventsData[all_eventsData.length-1].start_time) {
      //form_startDate = unixDateConversion(all_eventsData[all_eventsData.length-1].start_time);
      if (found_future_events) {
        form_endDate = unixDateConversion(all_eventsData[all_eventsData.length-1].start_time);
      } else {
        form_endDate = unixDateConversion(current_unix_stamp);
      }
    }
    
    this.setState({
      //zoomLevel: 2,
      startDate: form_startDate,
      endDate: form_endDate,
      eventsData,
      bannerSelectedCity: locations_text || '',
      selectedCity: locations_text || '',
      loading: false
    });
  }

  setToGlobal = async () => {

    /*
    if (this.workspace_base_url) {
      let org_data = await axios.get(`${apiUrl}organizations/${org_friendly_url}`);
      this.setState({ org_data });
      await this.orgEventSearch(org_data.entity_uuid);
      return;
    }
    */
    
    /*
    // setup map
    let latitude = 0;
    let longitude = 0;
    let locations_text = 'all'; // for eventsearch API call
    try {
      //console.log("EVENTS componentDidMount 1");
      let geo_data = await geoLocation(); // ask browser for location
      // we got user's lat/lon from browser
      latitude = geo_data.latitude;
      longitude = geo_data.longitude;
      //console.log("EVENTS componentDidMount 2",latitude,longitude);
      // we have user's geo data - so center the map!
      this.setState({
        user_lat: latitude,
        user_lon: longitude,
        bannerSelectedCity: '',
        initialCenter: { lat: latitude, lng: longitude },
        zoomLevel: 2,
      });
          
    } catch (err) {
      // we did not get user's lat/lon from browser - that is ok
      console.error("geoLocation failed: ",err);
    }
    */

    // get PK cities from the database via locationsearch API...closest first if we have user's geo data
    /*
    let [location_info] = await Promise.all([
      this.getLocationService(latitude,longitude,20038),
      this.defaultEventSearch()
    ]);
    */
    
    //await this.getLocationService(this.state.user_lat,this.state.user_lon,20038);
    await this.defaultEventSearch();

    // populate map with markers based on PK cities
    //this.setState({ stores: location_info });
    
    /*
    if (location_info.length > 0) {
      if (latitude || longitude) {
        //console.log("CLOSEST",JSON.stringify(location_info[0],null,2));
        locations_text = location_info[0].entity_name;
      }
  
      // get event data to display
      await this.defaultEventSearch(locations_text);
    } else {
      await this.defaultEventSearch();
    }
    */
    //await this.defaultEventSearch();
    
  }
  
  findClosestCity = async () => {
    this.onBannerCityChange([this.state.all_location_info[0].entity_name]);
    //await this.defaultEventSearch(this.state.all_location_info[0].entity_name);
  }

  async componentDidMount() {
    console.log("Events componentDidMount");
    if (this.workspace_base_url) {
      let org_data = await axios.get(`${apiUrl}organizations/${org_friendly_url}`);
      this.setState({ org_data });
      await this.orgEventSearch(org_data.entity_uuid);
      return;
    }
    
    // setup map
    let latitude = 0;
    let longitude = 0;
    //let locations_text = 'all'; // for eventsearch API call
    //let location_info = [];
    try {
      //console.log("EVENTS componentDidMount 1");
      let geo_data = await geoLocation(); // ask browser for location
      // we got user's lat/lon from browser
      latitude = geo_data.latitude;
      longitude = geo_data.longitude;
      
      //location_info = await this.getLocationService(latitude,longitude,20038);
      
      //console.log("EVENTS componentDidMount 2",latitude,longitude);
      // we have user's geo data - so center the map!
      this.setState({
        user_lat: latitude,
        user_lon: longitude,
        bannerSelectedCity: '',
        //initialCenter: { lat: latitude, lng: longitude },
        //zoomLevel: 2,
      });
          
    } catch (err) {
      // we did not get user's lat/lon from browser - that is ok
      console.error("geoLocation failed: ",err);
    }
    
    
    //this.setToGlobal();
    
    /*
    if (this.workspace_base_url) {
      let org_data = await axios.get(`${apiUrl}organizations/${org_friendly_url}`);
      this.setState({ org_data });
      await this.orgEventSearch(org_data.entity_uuid);
      return;
    }
    
    // setup map
    let latitude = 0;
    let longitude = 0;
    let locations_text = 'all'; // for eventsearch API call
    try {
      //console.log("EVENTS componentDidMount 1");
      let geo_data = await geoLocation(); // ask browser for location
      // we got user's lat/lon from browser
      latitude = geo_data.latitude;
      longitude = geo_data.longitude;
      //console.log("EVENTS componentDidMount 2",latitude,longitude);
      // we have user's geo data - so center the map!
      this.setState({
        initialCenter: { lat: latitude, lng: longitude },
        zoomLevel: 1,
      });
          
    } catch (err) {
      // we did not get user's lat/lon from browser - that is ok
      console.error("geoLocation failed: ",err);
    }
    */
    
    // get PK cities from the database via locationsearch API...closest first if we have user's geo data
    let [location_info] = await Promise.all([
      this.getLocationService(latitude,longitude,20038),
      this.defaultEventSearch()
    ]);

    // populate map with markers based on PK cities
    this.showAllCities();
    
    /*
    // CCC HACK
    // center on Japan
    let tokyo_obj = location_info.find( element => element.entity_name === 'Nagano');
    console.log("YO",tokyo_obj);
    this.setState({
      initialCenter: { lat: tokyo_obj.lat, lng: tokyo_obj.lon },
      zoomLevel: 5
    });
    */
    
    // center on user
    if (latitude && longitude) {
      this.setState({
        initialCenter: { lat: latitude, lng: longitude },
        zoomLevel: 4
      });
    }
    
    //this.setState({ stores: location_info });
    
    
    /*
    if (location_info.length > 0) {
      if (latitude || longitude) {
        //console.log("CLOSEST",JSON.stringify(location_info[0],null,2));
        locations_text = location_info[0].entity_name;
      }
  
      // get event data to display
      await this.defaultEventSearch(locations_text);
    } else {
      await this.defaultEventSearch();
    }
    */
    //await this.defaultEventSearch();

  }

  // get location info from the API; order by closest if we know user's lat/on
  async getLocationService (latitude, longitude, radius) {
    let response = await axios.get(`${location_search}?coordinates_lat=${latitude}&coordinates_lon=${longitude}&radius=${radius}`, HeaderConfig);

    const search_query_results = response.data && response.data.search_query_results ? response.data.search_query_results : null;

    let location_info = [];

    if (search_query_results) {
      let entity_info = search_query_results.map((data) => data.entity_info);
      location_info = entity_info.map(({ location_geopoint, entity_name, friendly_url, next_event }) => ({
        ...location_geopoint,
        entity_name,
        friendly_url,
        next_event: next_event || {},
        //show_marker: next_event ? true : false
      }));
      
      this.setState({
        all_location_info: location_info
      })
      
      //location_info = location_info.filter( element => element.next_event.event_name );
    }
    
    return location_info;
    
  }

  // fixup event array from defaultEventSearch
  getConstructedEventDataShort = (entities_arr) => {
    const eventsArray = []

    //console.log("EVENTS",JSON.stringify(entities_arr,null,2));
    
    let start_time, start_time_conv;
    
    let all_cities = [];
    
    entities_arr.forEach(function (entity_data, index) {
      //entity_data = entity.entity_info;
      start_time = unixDateConversion(entity_data.start_time);
      start_time_conv = dateConvert(start_time)
      let time_slot = start_time_conv.hour;
      var selectedDate = start_time;
      
      let days_left;
      if (selectedDate && selectedDate > new Date()) {
        let day_diff = DaysDiff(start_time);
        let hour_diff = HoursDiff(start_time);
        days_left = "Starts in " + day_diff + " days, " + hour_diff + " hours";
      } else {
        days_left = "Completed";
      }
      
      eventsArray[index] = ({
        entity_name: entity_data.entity_name,
        friendly_url: entity_data.friendly_url,
        entity_uuid: entity_data.entity_uuid,
        event_days_left: days_left,
        thumb_image_url: entity_data.thumb_image_url || null,
        poster_image_url: entity_data.poster_image_url,
        locations_text: entity_data.locations_text,
        Event_month: start_time_conv.month,
        Event_year: start_time_conv.year,
        Event_day: start_time_conv.day,
        Event_date: start_time_conv.date,
        Event_slot: time_slot,
        volume_integer: entity_data.volume_integer
      });
      
      all_cities.push(entity_data.locations_text);
    });
    
    let tmp_location_info = [...this.state.all_location_info];
    
    // do show_marker for affect cities
    for (let unique_city of new Set(all_cities)) {
      tmp_location_info.forEach( element => {
        if (element.entity_name === unique_city) {
          element.show_marker = true;
        }
      });
    }
    
    this.setState({
      //zoomLevel: 2,
      stores: tmp_location_info
    })

    return eventsArray;
  }

  // fixup event array from onApplyFilter
  getConstructedEventData = (response) => {
    const eventsArray = []
    const entities_arr = [];
    response.search_query_results.forEach(function (entities) {
      entities_arr.push(entities)
    })
    // eslint-disable-next-line 
    let entity_data, start_time, start_time_conv;
    
    let all_cities = [];
    
    entities_arr.forEach(function (entity, index) {
      entity_data = entity.entity_info;
      start_time = unixDateConversion(entity_data.start_time);
      start_time_conv = dateConvert(start_time)
      let time_slot = start_time_conv.hour;
      var selectedDate = start_time;
      
      let days_left;
      if (selectedDate && selectedDate > new Date()) {
        let day_diff = DaysDiff(start_time);
        let hour_diff = HoursDiff(start_time);
        days_left = "Starts in " + day_diff + " days, " + hour_diff + " hours";
      } else {
        days_left = "Completed";
      }
      
      eventsArray[index] = ({
        entity_name: entity_data.entity_name,
        friendly_url: entity_data.friendly_url,
        entity_uuid: entity_data.entity_uuid,
        event_days_left: days_left,
        thumb_image_url: entity_data.thumb_image_url || null,
        poster_image_url: entity_data.poster_image_url,
        locations_text: entity_data.locations_text,
        Event_month: start_time_conv.month,
        Event_year: start_time_conv.year,
        Event_day: start_time_conv.day,
        Event_date: start_time_conv.date,
        Event_slot: time_slot,
        volume_integer: entity_data.volume_integer
      });
      
      all_cities.push(entity_data.locations_text);
    })
    
    let tmp_location_info = [...this.state.all_location_info];
    
    // do show_marker for affect cities
    for (let unique_city of new Set(all_cities)) {
      tmp_location_info.forEach( element => {
        if (element.entity_name === unique_city) {
          element.show_marker = true;
        }
      });
    }
    
    this.setState({
      stores: tmp_location_info
    })
    
    return eventsArray;
  }
  
  
  // Events Section starts here
  EventsListChip = () => {
    const { eventsData } = this.state;
    return (
      <Row>
        {
          eventsData ? eventsData.map((item) =>
            <Col lg={4} key={item.entity_uuid} href="">
              <UpcomingEvents
                key={item.entity_uuid}
                id={item.entity_uuid}
                Event_img={item.thumb_image_url || item.poster_image_url}
                Event_time={item.event_days_left} Event_month={item.Event_month}
                Event_year={item.Event_year}
                Event_title={item.entity_name}
                Event_date={item.Event_date} Event_place={item.locations_text}
                Event_vol={item.volume_integer} Event_slot={item.Event_slot}
                Event_link={`${this.workspace_base_url}${local_routes.events}/${item.friendly_url}`}
              />
            </Col>) : null
        }
      </Row>
    );
  };
  
  onMapClicked = () => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      })
    }
  };

  handleEndDateChange = date => {
    // make sure endData is not less than startDate
    if (date < this.state.startDate) {
      //this.setState({ endDate: this.state.startDate });
      let tmp_startDate = this.state.startDate;
      tmp_startDate.setDate(tmp_startDate.getDate()-30);
      this.setState({ startDate: tmp_startDate, endDate: date });
    } else {
      this.setState({ endDate: date });
    }
  }

  handleStartDateChange = date => {
    // make sure endData is not less than startDate
    if (date > this.state.endDate) {
      //this.setState({ startDate: this.state.endDate });
      let tmp_endDate = this.state.endDate;
      tmp_endDate.setDate(tmp_endDate.getDate()+30);
      this.setState({ endDate: tmp_endDate, startDate: date });
    } else {
      this.setState({ startDate: date });
    }
  }

  handleTypeHeadSearch = loaderKey => query => {
    this.setState({[loaderKey]: true});
    axios.get(`${searchUrl}sitesearch_autocomplete?q=${query}&entity_type=locations`, HeaderConfig)
      .then(({data = []}) => {
        if (data.length) {
          this.setState({options: data, [loaderKey]: false});
        } else {
          this.setState({[loaderKey]: false});
        }
      })
      .catch(() => this.setState({[loaderKey]: false}));
  }

  getQueryValues = () => {
    const { endDate, startDate, selectedCity, sortValue, userTypedCity, org_sortValue } = this.state;
    const city = selectedCity || userTypedCity;
    const todayUnixDate = unixTimeStamp(new Date());
    const querySDate = startDate ? `&search_start_time=${unixTimeStamp(startDate)}` : `&search_start_time=${todayUnixDate}`;
    const queryEDate = endDate ? `&search_end_time=${unixTimeStamp(endDate)+86399}` : ''; // the form will pass midnight...we want all the way through the day
    const queryCity = city ? `&locations_text=${city}` : '';
    return {
      querySDate,
      queryCity,
      queryEDate,
      sortValue: this.workspace_base_url ? org_sortValue : sortValue
    };
  }

  onApplyFilter = async () => {
    const {
      querySDate,
      queryCity,
      queryEDate,
      sortValue,
    } = this.getQueryValues();

    //this.setState({ loading: true, eventsData: [] });
    this.setState({ loading: true });
    let response = await axios.get(`${events_search_list_api}?start_time_order=${sortValue}${queryCity}${querySDate}${queryEDate}&from=${0}&limit=${30}`, HeaderConfig);

    const eventsData = this.getConstructedEventData(response.data);
    this.setState({ loading: false, eventsData, isNoMoreEvents: false });

  }
  
  /*
  onCityChange = (selectedOptions) => {
    console.log("onCityChange",selectedOptions);
    this.setState({
      selectedCity: selectedOptions[0]
    });
  }
  */

  /*
  onCityInputChange = val => {
    if (this.state.bannerSelectedCity) {
      this.setState({
        bannerSelectedCity: val
      });
    }
  }
  */

  /*
  onCityInputBlur = (e) => {
    this.setState({userTypedCity: e.target.value});
  }
  */

  onBannerCityChange = (selectedOptions) => {
    console.log("onBannerCityChange",selectedOptions);
    const { google } = this.props;
    this.setState({ bannerSelectedCity: selectedOptions[0], selectedCity: selectedOptions[0] });
    
    const geocoder =  new google.maps.Geocoder();
    geocoder.geocode( { 'address': selectedOptions[0]}, async (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        // add a marker
        let tmp_location_info = [...this.state.all_location_info];
        tmp_location_info.forEach( (item) => {
          if (item.entity_name === selectedOptions[0]) {
            item.show_marker = true;
          }
        });
        //console.log("FOUND LOC INFO",tmp_location_info);
        
        this.setState({
          //stores: [...this.state.stores,tmp_location_info],
          stores: tmp_location_info,
          initialCenter: { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() },
          zoomLevel: 6,
          loading: true,
        });
        await this.defaultEventSearch(selectedOptions[0]);
        
      }
    });
    
  }

  showAllCitiesWithUpcomingEvents = () => {
    let tmp_location_info = [...this.state.all_location_info];
    tmp_location_info.forEach( (item) => {
      if (item.next_event && item.next_event.entity_uuid) {
        item.show_marker = true;
      } else {
        item.show_marker = false;
      }
    });
    console.log("showAllCitiesWithUpcomingEvents",tmp_location_info);
    this.setState({
      selectedCity: '',
      bannerSelectedCity: '',
      stores: tmp_location_info,
      zoomLevel: 2,
    });
    this.defaultEventSearch();
  }

  showAllCities = () => {
    let tmp_location_info = [...this.state.all_location_info];
    tmp_location_info.forEach( (item) => {
      item.show_marker = true;
    });
    console.log("showAllCities",tmp_location_info);
    this.setState({
      stores: tmp_location_info,
      zoomLevel: 2,
    })
  }

  // Load More Events Functionality
  loadMoreEvents = () => {
    const { loadMoreLoader, isNoMoreEvents } = this.state;
    return (
      <React.Fragment>
        {
          isNoMoreEvents ?
            <h4>No events...</h4> :
            <div>
              {loadMoreLoader ===true ?
                <ActivityIndicator theme="spinnerNoMargin" /> : 
              <p style={{textAlign: 'center', marginTop:'20px',color:'#fff'}}><span onClick={this.onLoadMoreClick} className="loadmore-btn">Load More...</span></p>
              }
              </div>
        }
      </React.Fragment>
    )
  }

  onLoadMoreClick = (e) => {
    e.preventDefault()
    const { eventsData } = this.state;
    const {
      querySDate,
      queryCity,
      sortValue,
      queryEDate,
    } = this.getQueryValues();
    this.setState({loadMoreLoader: true});
    const from = eventsData.length;
    axios.get(`${events_search_list_api}?start_time_order=${sortValue}${queryCity}${querySDate}${queryEDate}&from=${from}&limit=${30}`, HeaderConfig)
      .then((response) => {
        if (response.data && response.data.search_query_results && response.data.search_query_results.length) {
          const events = this.getConstructedEventData(response.data);
          this.setState(preState => {
            return {
              eventsData: [...preState.eventsData, ...events],
              isNoMoreEvents: false,
              loadMoreLoader: false,
            }
          });
        } else {
          this.setState({
            isNoMoreEvents: true,
            loadMoreLoader: false,
          });
        }
      })
      .catch(() => {
        this.setState({loadMoreLoader: false});
      });
  }
// Render method starts here
  render() {
    const {eventsData, loading, zoomLevel, stores, selectedMarkerData, initialCenter, startDate, endDate, options, isBannerLoading, bannerSelectedCity } = this.state;
    let dynamicProps = {};
    if (bannerSelectedCity) {
      dynamicProps.selected = [bannerSelectedCity];
    } else {
      dynamicProps.selected = [];
    }
    let eventFullDate = null;
    if (selectedMarkerData.startTime) {
      const covertedDate = unixDateConversion(selectedMarkerData.startTime);
      const formattedDate = dateConvert(covertedDate);
      eventFullDate = `${formattedDate.month} ${formattedDate.date},${formattedDate.year}`
    }
    return (

      <div className="main-section">
        <Helmet defer={false}>
          <title>PechaKucha Events Nearby</title>
          <meta name="description" content="Find PechaKucha Events near you" />
        </Helmet>
        
        <Row style={{ margin: 0 }}>
          {/* Event detail banner starts */}
          { !this.workspace_base_url &&
          <section className="events-top">
            <div className="container">
              <Row>
                <Col sm={12} md={6} lg={5}>
                  <Link style={{ fontSize: "smaller", marginTop: "5px" }} to={local_routes.eventcalendar}>Global Event Calendar</Link>
                  <div className="events-find">
                    
                    <h1>PechaKucha Night - Now in 1,200 cities around the world!</h1>
                    <p>The first PechaKucha Night was held in Tokyo and has since exploded to 1,200+ cities around the world. These events are geared towards people compelled to meet, network, and show their 20X20 PK presentations in public. Find a PechaKucha Night near you.</p>

                    <span style={{ color: "#007bff", cursor: "pointer", fontSize: "smaller", marginTop: "5px", textDecoration: "none" }} onClick={() => this.findClosestCity()}>Find My Closest PechaKucha City</span><br/>
                    <span style={{ color: "#007bff", cursor: "pointer", fontSize: "smaller", marginTop: "5px", textDecoration: "none" }} onClick={() => this.showAllCities()}>Show All PechaKucha Cities</span><br/>
                    <span style={{ color: "#007bff", cursor: "pointer", fontSize: "smaller", marginTop: "5px", textDecoration: "none" }} onClick={() => this.showAllCitiesWithUpcomingEvents()}>Show All Cities with Upcoming Events</span>
                    
                    {/*
                    { this.state.bannerSelectedCity &&
                      <React.Fragment>
                      <span style={{ color: "#007bff", cursor: "pointer", fontSize: "smaller", marginTop: "5px", textDecoration: "none" }} onClick={() => this.setToGlobal()}>Show All Cities with Upcoming Events</span>
                      </React.Fragment>
                    }
                    { this.state.showingAllCities &&
                      <span style={{ color: "#007bff", cursor: "pointer", fontSize: "smaller", marginTop: "5px", textDecoration: "none" }} onClick={() => this.setToGlobal()}>Show All Upcoming Global Events</span>
                    }
                    */}
                    <div className=" filter-nav event-search typeHead">
                      <i className="fa fa-search"></i>
                      <AsyncTypeahead
                        highlightOnlyResult={true}
                        id="typeahead1"
                        {...dynamicProps}
                        isLoading={isBannerLoading}
                        placeholder="Search by city name"
                        minLength={3}
                        onChange={this.onBannerCityChange}
                        onSearch={this.handleTypeHeadSearch('isBannerLoading')}
                        options={options}/>
                    </div>
                    
                  </div>

                </Col>
                <Col lg={7} md={6}>
                 
                </Col>
                
              </Row>
            </div>
            {/* Map Section */}
            <div className="event-map">
              <Map
                onClick={this.onMapClicked}
                google={this.props.google}
                // zoom={2}
                style={mapStyles}
                center={initialCenter}
                initialCenter={initialCenter}
                zoom={zoomLevel}
                className="allCityMap"
              >
                {this.displayMarkers(stores)}
                <InfoWindow
                  onClose={this.onInfoWindowClose}
                  marker={this.state.activeMarker}
                  visible={this.state.showingInfoWindow}>
                  <div style={{ padding: '0 10px' }}>
                    <a href={selectedMarkerData.url} rel="noopener noreferrer"><h5>{selectedMarkerData.name}</h5></a>
                    {selectedMarkerData.comingSoon ? <p>{selectedMarkerData.comingSoon}</p> : null}
                    {selectedMarkerData.eventName ? <p>{selectedMarkerData.eventName}</p> : null}
                    {eventFullDate ? <p><small>{eventFullDate}</small></p> : null}
                  </div>
                </InfoWindow>
              </Map>
            </div>
          </section>
          }
          <section className="events-filter">
            <div className="container">
              <Row>
                <Col sm={9} md={9} lg={9} className="mx-auto">
                  <div className="filters-inner">
                    <Row>
                      <Col sm={9} md={9} lg={9} className="mx-auto">
                        <div className="filter-nav typeHead">
                          <Row>
                            {/*
                            <Col md={3}>
                              <AsyncTypeahead
                                id="typeahead2"
                                {...dynamicProps}
                                isLoading={isLoading}
                                placeholder="Type any City"
                                minLength={3}
                                onChange={this.onCityChange}
                                onInputChange={this.onCityInputChange}
                                onBlur={this.onCityInputBlur}
                                onSearch={this.handleTypeHeadSearch('isLoading')}
                                options={options} />
                            </Col>
                            */}
                            <Col md={3} className="mx-auto">
                              <DatePicker
                                className="form-control"
                                placeholderText="Select start date"
                                // minDate={new Date()}
                                selected={startDate}
                                onChange={this.handleStartDateChange}
                              />
                            </Col>
                            <Col md={3} className="mx-auto">
                              <DatePicker
                                className="form-control"
                                placeholderText="Select end date"
                                // minDate={new Date()}
                                selected={endDate}
                                onChange={this.handleEndDateChange}
                              />
                            </Col>
                            <Col md={3} className="mx-auto">
                              <Button OnClickMet={this.onApplyFilter} theme=" btn-global btn-green font-small filter-btn" >Apply filter</Button>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      {/*
                      <Col sm={12} md={12} lg={4}>
                          <div className="sort-dropdown">
                          <label>Sort by</label>
                          <Form>
                            <Form.Group>
                              <div className="form-dropdownlist">
                                <Form.Control
                                  as="select"
                                  required
                                  // value={this.props.eventdropdown}
                                  onChange={this.onSortChange}
                                >
                                  <option value="ASC">Asc</option>
                                  <option value="DESC">Desc</option>
                                </Form.Control>
                              </div>
                            </Form.Group>
                          </Form>
                        </div>
                      </Col>
                      */}
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </section>
          {/* Event detail banner Ends */}
        </Row>
        
        <Container style={{minHeight: 300}}>
        {(eventsData === null) || eventsData.length ?
          <React.Fragment>
          {
            loading ?
            <ActivityIndicator theme="spinner" /> :
            <div>
              {
                 this.EventsListChip()
              }
              <React.Fragment>
              {
                eventsData !== null && eventsData.length > 29 &&
                <React.Fragment>
                {this.loadMoreEvents()}
                </React.Fragment>
              }
              </React.Fragment>
            </div>
          }
          </React.Fragment>
         :
          <h4>No events found</h4>
        }
        </Container>
        <Footer 
          homeImg={home}
          homeImgRef={this.workspace_base_url ? this.workspace_base_url : "/"}
          breadcrumbSubPage="Events"
        />
      </div>
    )
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyATS36RdvbWd9ESucCYIVvzqIxj3EFbQcg'
})(Events);
